import { useContext, useEffect } from 'react'
import { fetchTourDealFacets } from 'actions/tour/TourV2Actions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import GeoContext from 'contexts/geoContext'

type ReturnType = [
  App.Tours.TourDealFacets | undefined,
  boolean,
]

export function useTourDealFacets(slug: string | undefined): ReturnType {
  const dispatch = useAppDispatch()
  const facets = useAppSelector((state) => state.tour.tourDealFacets[slug ?? ''])
  const fetchingFacets = useAppSelector((state) => state.tour.fetchingTourDealFacetsBySlug[slug ?? ''])
  const { currentRegionCode } = useContext(GeoContext)
  useEffect(() => {
    if (slug) {
      dispatch(fetchTourDealFacets(slug, currentRegionCode.toUpperCase()))
    }
  }, [slug, dispatch, currentRegionCode])

  return [
    facets,
    fetchingFacets,
  ]
}
